import { CardHeader, Divider, CardContent, Typography, Stack, Box } from '@mui/material';
import { LocationOn } from '@mui/icons-material';
import Grid from '@mui/material/Grid2';

import type { SupplierProps } from '../../models';

interface TestingCentreProps {
	supplier?: Pick<SupplierProps, 'name' | 'address'>;
}

const style = {
	divider: {
		borderBottomWidth: 1.5,
	},
};

export const TestingCentre: React.FC<TestingCentreProps> = ({ supplier }) => (
	<>
		<CardHeader title="Testing Centre" />
		<Divider sx={style.divider} />
		<CardContent>
			<Grid size={{ xs: 12 }}>
				<Typography variant="h6">{supplier?.name}</Typography>
			</Grid>
			<Stack spacing={1} sx={{ mt: 2 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<LocationOn color="action" />
					<Typography variant="body1">{supplier?.address}</Typography>
				</Box>
			</Stack>
		</CardContent>
	</>
);
